/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 全局状态如：参数、用户信息、本地配置、数据库配置等状态管理
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-17 17:45:39
 * @LastEditTime: 2023-09-06 17:25:51
 * @FilePath: /client-h5-v2/src/store/modules/global.ts
 */
import { setCookie, getCookie } from '@/common-ts/utils'
export const global = {
  namespaced: true, // 防止模块命名冲突 设置后调用mutations和action需要'模块名/方法' 例如  app/setMenuList
  state: {
    // 项目名称
    projectName: '',
    // 地址栏携带的参数集合
    params: {},
    // 本地application-properties配置文件
    applicationProperties: {},
    // 获取页面配置数据
    pageConfig: {},
    // 用户信息（解析地址栏后加入的）
    userInfo: {},
    // 其他信息（除userInfo的参数）
    accessInfo: {},
    // 渠道
    channel: '',
    // 地区
    geo: '',
    // 语言
    language: '',
    // 国家
    country: '',
    // 场景编码
    scenarioCode: '',
    // 场景名称
    scenarioName: '',
    // i18n Element
    i18nElement: null,
    // 模版标识
    tmplMark: '',
    // 设备标识
    device: '',
    // 用户进入bot时间戳
    userEnterBotTime: Date.parse(String(new Date()))
  },
  getters: {
    projectName: (state: any) => state.projectName,
    params: (state: any) => state.params,
    applicationProperties: (state: any) => state.applicationProperties,
    pageConfig: (state: any) => state.pageConfig,
    userInfo: (state: any) => state.userInfo,
    accessInfo: (state: any) => state.accessInfo,
    channel: (state: any) => state.channel,
    geo: (state: any) => state.geo,
    language: (state: any) => state.language,
    country: (state: any) => state.country,
    scenarioCode: (state: any) => state.scenarioCode,
    scenarioName: (state: any) => state.scenarioName,
    i18nElement: (state: any) => state.i18nElement,
    tmplMark: (state: any) => state.tmplMark,
    device: (state: any) => state.device,
    countryList: (state: any) => state.countryList,
    userEnterBotTime: (state: any) => state.userEnterBotTime
  },
  mutations: {
    SET_PROJECT_NAME: (state: { projectName: string }, projectName: string) => {
      state.projectName = projectName
    },
    SET_PARAMS (state: { params: any }, params: any) {
      state.params = params
    },
    SET_APPLICATION_PROPERTIES (state: {applicationProperties: any}, applicationProperties: any) {
      state.applicationProperties = applicationProperties
    },
    SET_PAGE_CONFIG (state: {pageConfig: any}, pageConfig: any) {
      state.pageConfig = pageConfig
    },
    SET_USER_INFO (state: {userInfo: any}, userInfo: any) {
      state.userInfo = userInfo
      // 如果入口url中携带了userId（可以是映射列表中的所有可映射字段）
      if (userInfo.userId) {
        // 将映射后的userId放入cookie
        setCookie('userId', userInfo.userId)
        localStorage.setItem('userId', userInfo.userId)
      } else {
        // cookie中如果有就放入userInfo下，没有就是空串
        userInfo.userId = getCookie('userId') || localStorage.getItem('userId') || ''
      }
    },
    SET_ACCESS_INFO (state: {accessInfo: any}, accessInfo: any) {
      state.accessInfo = accessInfo
    },
    // 像state.accessInfo 中追加key和value
    SET_ACCESS_INFO_KEY_VALUE (state: {accessInfo: any}, {key, value}: {key: string, value: any}) {
      state.accessInfo[key] = value
    },
    SET_CHANNEL (state: {channel: string}, channel: string) {
      state.channel = channel
    },
    SET_GEO (state: {geo: string}, geo: string) {
      state.geo = geo
    },
    SET_LANGUAGE (state: {language: string}, language: string) {
      state.language = language
    },
    SET_COUNTRY (state: {country: string}, country: string) {
      state.country = country
    },
    SET_I18N_ELEMENT (state: {i18nElement: any}, i18nElement: any) {
      state.i18nElement = i18nElement
    },
    SET_USER_AGENT (state: {tmplMark: string}, tmplMark: string) {
      state.tmplMark = tmplMark
    },
    SET_SCENARIO_CODE (state: {scenarioCode: string}, scenarioCode: string) {
      state.scenarioCode = scenarioCode
    },
    SET_SCENARIO_NAME (state: {scenarioName: string}, scenarioName: string) {
      state.scenarioName = scenarioName
    },
    SET_DEVICE (state: {device: string}, device: string) {
      state.device = device
    },
    SET_COUNTRY_LIST (state: {countryList: string}, countryList: string) {
      state.countryList = countryList
    }
  },
  actions: {
  }
}

